import { OrganizerEvent } from './types';
import type { RelatedEvent } from '@/components/RelatedEvents/types';

export const NUMBER_OF_MORE_EVENTS_TO_DISPLAY = 5;

const getOrganizerEventDateValue = (event: OrganizerEvent): number => {
  if (!event.startDate) {
    return Number.POSITIVE_INFINITY;
  }

  const dateValue = Date.parse([event.startDate, event.startTime].filter(Boolean).join('T'));

  return Number.isNaN(dateValue) ? Number.POSITIVE_INFINITY : dateValue;
};

export const filterMoreOrganizerEvents = ({
  currentEventId,
  events,
}: {
  currentEventId: string;
  events?: OrganizerEvent[];
}): OrganizerEvent[] => {
  return (
    events
      ?.filter(
        (event: OrganizerEvent) => event.ticket_availability?.has_available_tickets && event.id !== currentEventId,
      )
      .map((event, index) => ({ event, index }))
      .sort((left, right) => {
        const dateDifference = getOrganizerEventDateValue(left.event) - getOrganizerEventDateValue(right.event);
        return dateDifference || left.index - right.index;
      })
      .map(({ event }) => event)
      .slice(0, NUMBER_OF_MORE_EVENTS_TO_DISPLAY) || []
  );
};

export const toRelatedEvent = (organizerEvent: OrganizerEvent): RelatedEvent => ({
  id: organizerEvent.id,
  name: organizerEvent.name,
  url: organizerEvent.url,
  imageUrl: organizerEvent.imageUrl,
  startDate: organizerEvent.startDate,
  startTime: organizerEvent.startTime,
  timezone: organizerEvent.timezone,
  isFree: organizerEvent.isFree,
  isOnlineEvent: organizerEvent.isOnlineEvent,
  isPromoted: organizerEvent.isPromoted,
  formattedPriceString: organizerEvent.formattedPriceString,
  venue: organizerEvent.venue,
  urgencySignals: organizerEvent.urgencySignals,
  specialDiscounts: organizerEvent.specialDiscounts,
  promotedListingMetadata: organizerEvent.promotedListingMetadata,
  savedByYou: organizerEvent.savedByYou,
  hasOpenDiscount: organizerEvent.hasOpenDiscount,
});
